import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";

type Notification = {
  type: string | null;
  unit?: string;
};

type PushContextType = {
  lastNotification: Notification;
  setLastNotification: (notification: Notification) => void;
};

const PushContext = createContext<PushContextType | undefined>(undefined);

export function PushProvider({ children }: { children: ReactNode }) {
  const [lastNotification, setLastNotification] = useState<Notification>({
    type: null,
    unit: undefined,
  });

  return (
    <PushContext.Provider value={{ lastNotification, setLastNotification }}>
      {children}
    </PushContext.Provider>
  );
}

export function usePush() {
  const context = useContext(PushContext);
  if (!context) throw new Error("usePush must be used within PushProvider");
  return context;
}
